import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { request } from '@core/api/request';
import { QUERY_KEYS } from '@shared/constants/query-keys';

import type { TSubscription } from '@shared/types/subscription';
import { useAuthStore } from '@src/core/store/auth-store';

export const getCurrentSubscription = async (): Promise<TSubscription> => {
  return request({
    url: `subscriptions/current/`,
  }).catch(() => {
    return Promise.resolve({ status: 'NONE' });
  });
};

export const useGetSubscription = (
  options?: Partial<UseQueryOptions<TSubscription>>
) => {
  const { accessToken } = useAuthStore();

  return useQuery({
    queryKey: [QUERY_KEYS.getCurrentSubscription],
    queryFn: getCurrentSubscription,
    staleTime: Infinity,
    enabled: !!accessToken,
    ...options,
  });
};
